<template>
  <v-container
    class="mt-16"
    id="Products"
    fluid
    tag="section"
  >
    <v-row>
      <v-col cols="12" lg="3" md="4" sm="6"  v-for="item in Products" :key="item">
        <v-card 
        max-width ="344"  
        class="mx-auto"
    >
       <v-list-item>
        <v-list-item-content>
          <v-list-item-title v-text="$t(item.name)" class="headline"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-img
        :src="getImgUrl(item.image)"
        height="200"
        width="200"
        class="ma-2 align-center"
      ></v-img>
         <v-card-text v-text="$t(item.description)">
        
      </v-card-text>
  
      
  
      <v-card-actions >
  
        <v-btn
          color="blue"
          v-text="$t('orderProduct')"
          @click="openDialog(item)"
        >
        </v-btn>
  
      
      </v-card-actions>
    </v-card>
      </v-col>
    </v-row>


 <v-dialog scrollable v-model="dialog" persistent max-width="400" >
     
        <v-card>
          <v-card-title>
            <span class="headline" v-text="$t('orderProduct')"></span>
          </v-card-title>
          <v-card-text>
          

                <v-row>
            <v-col cols="12" >
             <label v-text='$t("ProductNameForm")'> </label><label>{{orderObject.name}}</label>
            </v-col>

            <v-col cols="12" >
              <v-text-field dense outlined  :label='"*"+$t("email")' solo></v-text-field>
            </v-col>

            <v-col cols="12" >
              <v-textarea dense outlined  :label='"*"+$t("message")' solo></v-textarea>
            </v-col>

            <v-col class="mx-auto" cols="auto">
             
            </v-col>
          </v-row>
          </v-card-text>
          <v-card-actions>
             <v-btn color="blue" x-large v-text='$t("send")'>
                
              </v-btn>
            <v-btn color="blue darken-1" text @click="dialog = false" v-text='$t("closeDialog")'></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>




  </v-container>
</template>

<script>
  export default {
    
    


    data: () => ({
      dialog:false,
      orderObject:{
        name:'',
        image:'',
        description:'',
      },
      Products:[
         {name:'DRBLIDTIGHE',
        image:'bladeCollection',
        description:'descriptionDRBLIDTIGHE',
        },
        
        {name:'ANILOX',
        image:'Untitled-2',
        description:'descriptionANILOX',
        },
        {name:'ANILOXWASHERBRUSH',
        image:'Untitled-21',
        description:'descriptionANILOXWASHERBRUSH',
        },
         {name:'3DMGLOW',
        image:'3m',
        description:'description3DMGLOW',
        },
        {name:'ANILOXWASHER',
        image:'3dmglow',
        description:'descriptionANILOXWASHER',
        },
        {name:'ENDSEAL',
        image:'Untitled-3',
        description:'descriptionENDSEAL',
        },
        {name:'ANGEL',
        image:'angle',
        description:'descriptionANGEL',
        },
        {name:'LAMINATION',
        image:'lamination',
        description:'descriptionLAMINATION',
        },
       
       
      ],
      show: false,
    }),
      methods: {
        openDialog(item){
          this.dialog =true;
          this.orderObject.name =  this.$t(item.name);
        },
      getImgUrl(pet) {
      debugger;
    var images = require.context('../../../assets/products/', false, /\.png$/)
    return images('./' + pet + ".png")
  }
  }

  }
</script>
